import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/arrow-down.svg';

export const IconArrowDown: IconComponent = props => <Icon {...props} src={src} />;
